import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet';
import * as metadata from './metadata';
import lazySizes from 'lazysizes';
import './styles/base.css';
import './styles/cabEnhancement.css';
import './styles/cabSeoSprite.css';
import './styles/ePassSprite.css';
import loadable from '@loadable/component';
import delayedScheduler from './scheduler';
import { config, landingConfig } from './constants/adsConfig';
import { pageLoadedInBrowser } from './utils/commonUtils';
import {
  SEO_CABS_LANDING_PAGE,
  STATIC_CAB_FAQ_PAGE
} from './constants/templateConstants';
import 'regenerator-runtime/runtime';
import { MMTHeader } from './components/MMTHeader';

// keep common css folder for files that are being used
const CabsPolicies = loadable(() =>
  import('./pages/CabsPolicies/CabsPolicies')
);
const TripGuaranteePage = loadable(() =>
  import('./pages/TripGuarantee/TripGuarantee')
);
const PdfPage = loadable(() => import('./pages/PdfPage/PdfPage'));
const CityOperatorTemplate = loadable(() =>
  import('./pages/CityOperatorTemplate/CityOperatorTemplate')
);
const CityTemplate = loadable(() =>
  import('./pages/CityTemplate/CityTemplate')
);
const AirportTemplate = loadable(() =>
  import('./pages/AirportTemplate/AirportTemplate')
);
const EPassPage = loadable(() => import('./pages/EPassPage/EPassPage'));
const RouteOperatorTemplate = loadable(() =>
  import('./pages/RouteOperatorTemplate/RouteOperatorTemplate')
);
const OperatorTemplate = loadable(() =>
  import('./pages/OperatorTemplate/OperatorTemplate')
);
const RouteTemplate = loadable(() =>
  import('./pages/RouteTemplate/RouteTemplate')
);
const RouteCarTypeTemplate = loadable(() =>
  import('./pages/RouteCarTypeTemplate/RouteCarTypeTemplate')
);
const CityCarTypeTemplate = loadable(() =>
  import('./pages/CityCarTypeTemplate/CityCarTypeTemplate')
);
// const CityRydeTemplate = loadable(() =>
//   import('./pages/CityRydeTemplate/CityRydeTemplate')
// );
// const RouteRydeTemplate = loadable(() =>
//   import('./pages/RouteRydeTemplate/RouteRydeTemplate')
// );
const OutStationOneWayPage = loadable(() =>
  import('./pages/OutStationOneWayPage/OutStationOneWayPage')
);
const RydeHomePage = loadable(() => import('./pages/RydePage/RydeHomePage'));
const AirportHomePage = loadable(() =>
  import('./pages/AirportHomePage/AirportHomePage')
);
const RentalHomePage = loadable(() =>
  import('./pages/RentalHomePage/RentalHomePage')
);
const CityHRTemplate = loadable(() =>
  import('./pages/CityHRTemplate/CityHRTemplate')
);
const AirportToCityRouteTemplate = loadable(() =>
  import('./pages/AirportToCityRoutePage/AirportToCityRouteTemplate')
);
const CityToAirportRouteTemplate = loadable(() =>
  import('./pages/CityToAirportRoutePage/CityToAirportRouteTemplate')
);
const CabsLandingPage = loadable(() =>
  import('./pages/CabsLandingPage/CabsLandingPage')
);
const MultiCityPage = loadable(() =>
  import('./pages/MultiCityPage/MultiCityPage')
);
const MultiCityPage2 = loadable(() =>
  import('./pages/MultiCityPage/MultiCityPage2')
);
const FaqPage = loadable(() => import('./pages/FaqPage/FaqPage'));
require('isomorphic-fetch');

// Adding delayScheduler to pwatracker scheduler : window.schedulerDelay
if (
  typeof window !== 'undefined' &&
  typeof window.requestIdleCallback === 'function'
) {
  window.schedulerDelay = delayedScheduler;
}

const NoMatch = ({ location }) => (
  <div>
    <h3>
      No match for <code>{location.pathname}</code>
    </h3>
  </div>
);

const App = ({ data }) => {
  const { templateName } = data.templateData;
  if (pageLoadedInBrowser()) {
    const { setConfig } = require('ad-react-wrapper');
    templateName === SEO_CABS_LANDING_PAGE
      ? setConfig(landingConfig)
      : setConfig(config);
  }

  return (
    <>
      {templateName === SEO_CABS_LANDING_PAGE ||
      templateName === STATIC_CAB_FAQ_PAGE ||
      (templateName && String(templateName).startsWith('DOC')) ? null : (
        <div className={`desktopShow`} style={{ height: 65 }}>
          {' '}
          <MMTHeader />
        </div>
      )}
      <Helmet
        title={data.templateData.metaTitle}
        meta={metadata.meta}
        script={metadata.script}
        noscript={metadata.noscript}
      />
      <div>
        <Switch>
          <Route
            exact
            path="/airportToCityRoute/:a2cRouteId"
            render={props => (
              <AirportToCityRouteTemplate data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/car-rental/airport-cabs-from-*-to-*.html"
            render={props => (
              <AirportToCityRouteTemplate data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/cityToAirportRoute/:c2aRouteId"
            render={props => (
              <CityToAirportRouteTemplate data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/car-rental/airport-taxi-from-*-to-*.html"
            render={props => (
              <CityToAirportRouteTemplate data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/cityHR/:cityHRId/"
            render={props => <CityHRTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/rental-cabs-in-*.html/"
            render={props => <CityHRTemplate data={data} {...props} />}
          />
          {/* <Route
            exact
            path="/cityRyde/:cityRydeId/"
            render={props => <CityRydeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/ryde-cabs-in-*.html"
            render={props => <CityRydeTemplate data={data} {...props} />}
          /> */}
          {/* <Route
            exact
            path="/routeRyde/:routeRydeId/"
            render={props => <RouteRydeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/ryde-cabs-from-*.html"
            render={props => <RouteRydeTemplate data={data} {...props} />}
          /> */}
          <Route
            exact
            path="/city/:cityCode"
            render={props => <CityTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-city-cabs.html"
            render={props => <CityTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/airport/:airportCode"
            render={props => <AirportTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-airport-taxi.html"
            render={props => <AirportTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/cab-services-in-*.html"
            render={props => <MultiCityPage2 data={data} {...props} />}
          />
          <Route
            exact
            path="/cityOperator/:cityCode/:operatorCode"
            render={props => <CityOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-services-in-*.html"
            render={props => <CityOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/covid-epass.html"
            render={props => <EPassPage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/covid-epass.html"
            render={props => <EPassPage data={data} {...props} />}
          />
          <Route
            exact
            path="/routeOperator/:routeId/:operatorId"
            render={props => <RouteOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-services-from-*-to-*.html"
            render={props => <RouteOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/route/:routeId"
            render={props => <RouteTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-cab-services.html"
            render={props => <RouteTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/routeCarType/:routeCarTypeId"
            render={props => <RouteCarTypeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-cabs-from-*.html"
            render={props => <RouteCarTypeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/cityCarType/:cityCarTypeId"
            render={props => <CityCarTypeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-cabs-in-*.html"
            render={props => <CityCarTypeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/tempo-traveller-in-*.html"
            render={props => <CityCarTypeTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/operator/:operatorId"
            render={props => <OperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-online-booking.html"
            render={props => <OperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/one-way-cab.html"
            render={props => <OutStationOneWayPage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/one-way-cab.html"
            render={props => <OutStationOneWayPage data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/ryde-cab.html"
            render={props => <RydeHomePage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/ryde-cab.html"
            render={props => <RydeHomePage data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/airport-taxi.html"
            render={props => <AirportHomePage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/airport-taxi.html"
            render={props => <AirportHomePage data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/"
            render={props => <RentalHomePage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/car-rental/"
            render={props => <RentalHomePage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/cabs/faqs"
            render={props => <FaqPage data={data} {...props} />}
          />
          <Route
            exact
            path="/cabs/faqs"
            render={props => <FaqPage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/cabs/"
            render={props => <CabsLandingPage data={data} {...props} />}
          />
          <Route
            exact
            path="/cabs/"
            render={props => <CabsLandingPage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/doc/ride-guarantee.html"
            render={props => <TripGuaranteePage data={data} {...props} />}
          />
          <Route
            exact
            path="/doc/ride-guarantee.html"
            render={props => <TripGuaranteePage data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/doc/cabs-policies.html"
            render={props => <CabsPolicies data={data} {...props} />}
          />
          <Route
            exact
            path="/doc/cabs-policies.html"
            render={props => <CabsPolicies data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/doc/*"
            render={props => <PdfPage data={data} {...props} />}
          />
          <Route
            exact
            path="/doc/*"
            render={props => <PdfPage data={data} {...props} />}
          />
          <Route
            exact
            path="/multiCity/:multiCityId"
            render={props => <MultiCityPage data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/multi-city-stops-from-*-to-*.html" // irule /car-rental/multi-city-stops*
            render={props => <MultiCityPage data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/char-dham-yatra-cabs-multiple-stops.html" // irule /car-rental/multi-city-stops*
            render={props => <MultiCityPage data={data} {...props} />}
          />
          <Route
            exact
            path="/car-rental/*-multiple-stops.html" // irule /car-rental/multi-city-stops*
            render={props => <MultiCityPage data={data} {...props} />}
          />
          <Route
            exact
            path="/state/:stateId"
            render={props => <MultiCityPage2 data={data} {...props} />}
          />
          <Route component={NoMatch} />
        </Switch>
      </div>
    </>
  );
};

export default App;
